import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ExpertiseService} from "../../../../shared/services/expertise.service";
import {finalize} from "rxjs/internal/operators/finalize";

@Component({
  selector: 'app-check-expertise-modal',
  templateUrl: './check-expertise-modal.component.html',
  styleUrls: ['./check-expertise-modal.component.scss']
})
export class CheckExpertiseModalComponent {

  expInfo: IExpInfo;

  constructor(public dialogRef: MatDialogRef<CheckExpertiseModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CheckExpertiseModalComponentData,
              private expService: ExpertiseService) {
    this.expInfo = data?.expertiseInfo;
  }

  attach() {
    this.dialogRef.close({type: 'attach'});
  }

  close() {
    this.dialogRef.close({type: 'close'});
  }

  loader = false;

  accept() {
    this.loader = true;
    this.expService.acceptConclusionFile(this.expInfo.docDate, this.expInfo.docNumber, this.expInfo.fileID, this.expInfo.expertiseID)
      .pipe(
        finalize(() => this.loader = false)
      )
      .subscribe(result => {
        this.dialogRef.close({type: 'accept', result});
      });
  }
}

export interface CheckExpertiseModalComponentData {
  errorStatus: number;
  objectName: string;
  incomeObjectName: string;
  errorText: string;
  expertiseInfo: IExpInfo;
}

interface IExpInfo {
  docNumber: string;
  docDate: string;
  fileID: number;
  expertiseID: number;
}
